import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { catchError, map, of } from 'rxjs';

export const checkTokenGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }

  // Interceptor automatycznie obsłuży 401 – spróbuje odświeżyć token
  // i ponowi żądanie. Guard dostaje wynik PO ewentualnym refreshu.
  // catchError tutaj obsługuje tylko przypadek gdy refresh też się nie udał
  // (interceptor wyczyścił tokeny i przekierował – ale guard też to zabezpiecza).
  return auth.checkToken().pipe(
    map(() => {
      if (auth.isPlatformAdmin()) {
        return true;
      }
      auth.clearTokens();
      return router.createUrlTree(['/login']);
    }),
    catchError(() => {
      // Refresh się nie powiódł – interceptor już wyczyścił tokeny i przekierował,
      // ale na wszelki wypadek upewniamy się tutaj też
      auth.clearTokens();
      return of(router.createUrlTree(['/login']));
    })
  );
};
